import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { LuPartyPopper, LuX } from 'react-icons/lu';

import { rotaDoRelatorio, useReportContext } from '../../../providers/ReportContext';

/**
 * Aviso de relatorio pronto, para quem estava em outra tela quando o calculo
 * terminou. Mais forte que as notificacoes comuns de proposito: nao some sozinho,
 * fica acima delas e oferece abrir o relatorio - em vez de a pagina trocar
 * sozinha no meio do que a pessoa estava fazendo.
 */
export function AvisoRelatorioPronto() {
    const { relatorioPronto, fecharRelatorioPronto } = useReportContext();
    const navigate = useNavigate();

    if (!relatorioPronto) return null;

    const nome = relatorioPronto.tipo === 'Rem' ? 'remarcação' : 'estoque ideal';

    const abrir = () => {
        fecharRelatorioPronto();
        navigate(`${rotaDoRelatorio(relatorioPronto.tipo)}?r=${relatorioPronto.id}`);
    };

    return (
        <div className="aviso-pronto" role="alertdialog" aria-live="assertive" aria-labelledby="aviso-pronto-titulo">
            <span className="aviso-pronto-icone" aria-hidden="true"><LuPartyPopper /></span>
            <div className="aviso-pronto-textos">
                <strong id="aviso-pronto-titulo">Seu relatório está pronto</strong>
                <span>O relatório de {nome} terminou de ser gerado. Abra quando quiser — ele também fica marcado como novo no Dashboard.</span>
                <div className="aviso-pronto-acoes">
                    <Button type="primary" onClick={abrir}>Abrir relatório</Button>
                    <Button type="text" className="aviso-pronto-depois" onClick={fecharRelatorioPronto}>Depois</Button>
                </div>
            </div>
            <button type="button" className="aviso-pronto-fechar" onClick={fecharRelatorioPronto} aria-label="Fechar aviso">
                <LuX />
            </button>
        </div>
    );
}
